import { Component, Element, h, Host, Prop, State } from '@stencil/core';

@Component({
  tag: 'sy-blog-banner-item',
  styleUrl: 'scss/index.scss',
  shadow: true,
})
export class SyBlogBannerItem {
  private resizeObserver: ResizeObserver;
  private buttonType: string;

  @Element() el: HTMLSyBlogBannerItemElement;
  /**
   * Banner identifier
   */
  @Prop({ reflect: true }) identifier: string;

  /**
   * Banner background
   */
  @Prop({ reflect: true }) backgroundType: string;

  /**
   * Banner background
   */
  @Prop({ reflect: true }) backgroundColor: string;

  /**
   * Banner background
   */
  @Prop({ reflect: true }) desktopBackgroundImage?: string;

  /**
   * Banner background
   */
  @Prop({ reflect: true }) mobileBackgroundImage?: string;

  /**
   * Which side is image
   */
  @Prop({ reflect: true }) showImageOnRightSide: boolean;

  /**
   * Desktop image
   */
  @Prop({ reflect: true }) desktopImage?: string;

  /**
   * Mobile image
   */
  @Prop({ reflect: true }) mobileImage?: string;

  /**
   * HTML generated content
   */
  @Prop({ reflect: true }) htmlContent: string;

  /**
   * CTA Icon
   */
  @Prop({ reflect: true }) ctaIcon: string;

  /**
   * CTA Label
   */
  @Prop({ reflect: true }) ctaLabel: string;

  /**
   * CTA Link
   */
  @Prop({ reflect: true }) ctaHref: string;

  /**
   * CTA Target
   */
  @Prop({ reflect: true }) buttonTarget: '_self' | '_blank' = '_blank';

  @State() isMobile: boolean;

  componentWillLoad() {
    this.buttonType = this.ctaIcon && this.ctaIcon !== 'null' ? 'icon-right' : 'text-only';
  }

  componentDidLoad() {
    this.setResizeObserver();
  }

  private setResizeObserver(): void {
    const bannerMaxMobileWidth = 400;
    if (!window.ResizeObserver) return;

    this.resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        this.isMobile = entry?.contentRect?.width < bannerMaxMobileWidth;
      }
    });

    this.resizeObserver.observe(this.el);
  }

  private getBackground() {
    if (this.backgroundType === 'color') {
      return { background: this.backgroundColor };
    } else if (this.backgroundType === 'image') {
      let imageSourceBackground = this.desktopBackgroundImage || this.mobileBackgroundImage;

      if (this.isMobile && this.mobileBackgroundImage) {
        imageSourceBackground = this.mobileBackgroundImage;
      }

      return {
        backgroundImage: 'url(' + imageSourceBackground + ')',
      };
    }
  }

  render() {
    let imageSource = this.desktopImage || this.mobileImage;

    if (this.isMobile && this.mobileImage) {
      imageSource = this.mobileImage;
    }

    return (
      <Host>
        <div class={`banner-container ${this.isMobile ? 'mobile-version' : ''}`} style={this.getBackground()}>
          <div class="banner-content">
            {imageSource && (
              <sy-blog-img
                loading="eager"
                alt={this.identifier}
                title={this.identifier}
                srcsetWidths={[576, 1200]}
                source={imageSource}
                class={`banner-image ${this.showImageOnRightSide ? 'image-right' : 'image-left'}`}
              ></sy-blog-img>
            )}
            <div class="text-content">
              <div class="html-content" innerHTML={this.htmlContent}></div>
              <div class="button">
                <sy-button
                  id={`banner-button-${this.identifier}`}
                  content={this.buttonType}
                  icon={this.ctaIcon}
                  variant="filled"
                  color="secondary"
                  label={this.ctaLabel}
                  href={this.ctaHref}
                  target={this.buttonTarget}
                ></sy-button>
              </div>
            </div>
          </div>
        </div>
      </Host>
    );
  }
}
